import React from 'react';
import ReactDOM from 'react-dom/client';
import { WrappedClarityApp } from './App';

// ── Bundled fonts (fully offline, no Google Fonts needed) ──
import '@fontsource/quicksand/400.css';
import '@fontsource/quicksand/500.css';
import '@fontsource/quicksand/600.css';
import '@fontsource/quicksand/700.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/500.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';
import '@fontsource/pacifico/400.css';
import '@fontsource/comfortaa/400.css';
import '@fontsource/comfortaa/500.css';
import '@fontsource/comfortaa/600.css';
import '@fontsource/comfortaa/700.css';
import '@fontsource/caveat/400.css';
import '@fontsource/caveat/500.css';
import '@fontsource/caveat/600.css';
import '@fontsource/caveat/700.css';

// App-wide default font. Needed as a real CSS rule (not just the inline
// style on App's root div) because several screens (e.g. the journal editor
// on mobile/tablet widths) render via createPortal(..., document.body),
// landing outside that root div and otherwise falling back to the
// browser/WebView's default sans-serif (Arial on most platforms).
const globalFontStyle = document.createElement('style');
globalFontStyle.textContent = `body { font-family: 'Quicksand', sans-serif; }`;
document.head.appendChild(globalFontStyle);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<WrappedClarityApp />);
